import { useEffect, useState, useRef } from "react";
import { BsInfoCircle } from "react-icons/bs"
import { FiUpload } from "react-icons/fi"
import { useParams } from "react-router-dom";
import WebService from "../../../../utility/WebService";
import { Controller, useForm } from "react-hook-form";
import CustomDropdown from "../../../../components/Select/CustomDropdown";
import SucessModal from "../../../../components/SucessModal/Sucess";
import WarningModal from "../../../../components/Warning/Warning";
import loader from "../../../../assets/images/button-loader.svg"
import toast from "../../../../components/AppModal/AppModal";
import CustomDatePicker from "../../../../components/DatePicker/CustomDatePicker";
import HelperService from "../../../../utility/HelperService";
import moment from "moment";
import { useNavigate, useLocation } from "react-router-dom";
import { SkeletonBar } from "../../../../components/Skeleton/Skeleton";
// @ts-ignore
import "./AddAgreement.css";
import { useMenuBack } from "../../../../hooks/useMenuBack";
import { useActionsFloating } from "../../../../hooks/useActionsFloating";

/* ---- small inline field icons (kept local to this screen) ---- */
const IconBack = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7" /></svg>
);
const IconError = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9" /><path d="M12 8v4m0 4h.01" /></svg>
);
const IconDoc = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14 3H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V8z" /><path d="M14 3v5h5M9 13h6M9 17h6" /></svg>
);
const IconUser = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 4-6 8-6s8 2 8 6" /></svg>
);
const IconType = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.6 13.4L11 3.8A2 2 0 009.6 3.2H4a1 1 0 00-1 1v5.6a2 2 0 00.6 1.4l9.6 9.6a2 2 0 002.8 0l4.6-4.6a2 2 0 000-2.8z" /><circle cx="7.5" cy="7.5" r="1.2" /></svg>
);
const IconClock = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
);
const IconCalendar = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 9h18M8 3v4m8-4v4" /></svg>
);
const IconUploadCloud = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M16 16l-4-4-4 4M12 12v9" /><path d="M20.4 15A5 5 0 0018 6.5 6.5 6.5 0 005.5 9 4.5 4.5 0 006 18h1" /></svg>
);

/* ---- page-specific skeleton shown while the edit/renew record loads ---- */
const AgreementFormSkeleton = () => (
    <div className="aagr-card" aria-hidden="true">
        <div className="aagr-card-head">
            <SkeletonBar w={38} h={38} r={11} />
            <div>
                <SkeletonBar w={160} h={16} />
                <SkeletonBar w={210} h={11} style={{ marginTop: 8 }} />
            </div>
        </div>
        <div className="aagr-fields">
            {[0, 1, 2, 3].map((i) => (
                <div key={i}>
                    <SkeletonBar w={120} h={12} style={{ marginBottom: 10 }} />
                    <SkeletonBar w="100%" h={42} r={10} />
                </div>
            ))}
        </div>
    </div>
);

const AddAgreement = () => {
  const goBack = useMenuBack();
    const {
        register,
        handleSubmit,
        control,
        setValue,
        watch,
        reset,
        formState: { errors },
    } = useForm();
    let { id } = useParams();
    let { p_id } = useParams();
    const watchAllFields = watch();
    const [clientOption, setClientOption] = useState<any[]>([]);
    const [clientValue, setClientValue] = useState<any>();
    const [isLoading, setLoading] = useState(false);
    const [sucessMessage, setSucessMessage] = useState<any>()
    const [isShowSucessModal, setShowSucessModal] = useState(false);
    const [warningMessage, setWarningMessage] = useState<any>()
    const [isShowWarningModal, setShowWarningModal] = useState(false);
    const [image, setImage] = useState<any>({});
    const [documentName, setDocumentName] = useState('');
    const [agreementTypeSelected, setAgreementTypeSelected] = useState<any>();
    const [endDate, setEndDate] = useState(null);
    const [startDate, setStartDate] = useState('');
    const [newStartDate, setNewStartDate] = useState<any>(new Date())
    const { pathname, state } = useLocation();
    const [showLoader, setShowLoader] = useState(false);
    const currentPath = window.location.pathname;
    const isRenewAgreement = currentPath.includes("renew-agreement");
    const pageRef = useRef<HTMLDivElement>(null);
    // bottom action bar floats as a sticky card only when the page scrolls
    const isActionsFloating = useActionsFloating(pageRef, [showLoader, watchAllFields.duration_type, documentName]);

    useEffect(() => {
        getStartDate();
        if(id){
            getDetail(id);
        }
        getAllClientList();
        // console.log(convertedDate)
    }, []);
    const getStartDate = (date?: number) => {
        const dates = date ? new Date(date) : new Date();
        const todaysStartDate: any = new Date(dates.getTime());
        const convertedDate: any = moment.utc(todaysStartDate).format("YYYY-MM-DD");
        setValue("start_date", convertedDate);
        setStartDate(convertedDate);
    };
    // console.log(startDate)
    const getAllClientList = () => {
        WebService.getAPI({
            action: `/v2/UserProfile/GetAllClientList`,
            body: null
        })
            .then((res: any) => {
                var array: any = [];
                for (var i in res.list) {
                    array.push({ id: res.list[i].id, value: res.list[i].name });
                }
                setClientOption(array);
                if (id) {
                    setClientValue(id)
                }
            })
            .catch((e) => {
            })
    }
const handleNewStartDate =(data:any)=>{
    const date = new Date(data);
    const dateString = date.toISOString().split("T")[0];
    setNewStartDate(dateString);

}

const getDetail = (id :any) =>{
    setShowLoader(true);
        WebService.getAPI({
            action: `/v2/ClientAgreements/GetAgreementDetails?id=${id}&p_id=${p_id}`,
            body: null
        })
            .then((res: any) => {
                setShowLoader(false);
                reset(res.result);
                if(isRenewAgreement){
                    const endDate = res.result.end_date;
                    const newStartDate = endDate ? new Date(endDate) : new Date();
                    newStartDate.setDate(newStartDate.getDate() + 1);
                    const formattedStartDate = moment(newStartDate).format("YYYY-MM-DD");
                    setValue("start_date", endDate ? formattedStartDate : moment(newStartDate).format('YYYY-MM-DD'));
                    setStartDate(formattedStartDate);
                    setValue("duration_type", '');
                }else{
                    setStartDate(res.result.start_date);
                    setValue("duration_type", res.result.duration_type);
                    if(res.result != ""){
                        setValue('start_date', res.result.start_date);
                    }else{
                        getStartDate();
                    }
                    setValue('end_date', res.result.end_date);
                    setValue('document_name' , res.result.document_name);
                    setDocumentName(res.result.display_document_name);
                    setImage(res.result.document_name)
                    setAgreementTypeSelected(res.result.agreement_type);
                    setValue('agreement_type' , res.result.agreement_type);
                    setEndDate(res.result.end_date);
                }
            })
            .catch(() => {
                setShowLoader(false);
            });
}

    const onSave = (data: any) => {
        data.is_renewal = isRenewAgreement ? 1 : 0
        let fileName = image.name ? image.name : image;
        let extension = fileName.split(".").pop();
        if (extension == "pdf") {
            var form = new FormData();
            form.append('client_id', id ? id : data.client_id);
            if(p_id){
            form.append('p_id', p_id );
            }
            form.append('agreement_type', data.agreement_type);
            form.append('duration_type', data.duration_type);
            form.append('start_date', data.start_date ? data.start_date : "");
            form.append('end_date', data.end_date ? data.end_date : "" );
            form.append('is_renewal', data.is_renewal);
            if (image) {
                form.append('ClientAgreements[original_agreement]', image);
            }
            setLoading(true);
            WebService.fileUploadAPI({
                action: `/v2/ClientAgreements/AddAggrement`,
                body: form,
            })
                .then((res: any) => {
                    setShowSucessModal(true);
                    setSucessMessage(res.message);
                    goBack();
                })
                .catch((e) => {
                    setShowWarningModal(true);
                    setWarningMessage(e.response.data.message)
                    setLoading(false);
                });
        } else {
            setShowWarningModal(true);
            setWarningMessage("File type must be PDF")
        }
    };

    

    const onLoadImage = (event: any) => {
        const { files } = event.target;
        if (files && files[0]) {
            const fileSize = files[0].size / 1024 / 1024; // size in MB
            if (fileSize > 50) {
                toast.error('File size should not exceed 50 MB');
            } else {
            setDocumentName(files[0].name);
            setValue("document_name", files[0].name)
            setImage(files[0])
            }
        }
        event.target.value = '';
    };

    const warningCloseModal = () => {
        setShowWarningModal(false)
        setLoading(false);
    };

    const sucessCloseModal = () => {
        setShowSucessModal(false)
        setLoading(false);
    }

    const agreementType = [
        { id: "AADHAR_E_SIGN", value: "Aadhar E-Sign" },
        { id: "E_SIGN", value: "Normal Wet E-sign" },
        // { id: "SCANED_BY_CLIENT", value: "Physical copy scanned by client" },
        { id: "SCANED_BY_BOTH", value: "Physical copy scanned by both parties" }
    ]
    return (
        <>
            <SucessModal
                show={isShowSucessModal}
                isClose={sucessCloseModal}
                message={sucessMessage}
            />
            <WarningModal
                show={isShowWarningModal}
                isClose={warningCloseModal}
                message={warningMessage}
            />
            <div className="page-content-wraper aagr-page" ref={pageRef}>
                <form onSubmit={handleSubmit(onSave)}>
                    {/* ---------- top bar ---------- */}
                    <div className="aagr-topbar">
                        <div className="aagr-crumb">
                            <button type="button" className="aagr-back" onClick={goBack} title="Back">
                                <IconBack />
                            </button>
                            <div>
                                <h1>{id ? (id ? (isRenewAgreement ? (`Renew Agreement : ${state?.name}`) : (`Edit Agreement : ${state?.name}`)) : `Create Agreement : ${state?.name}`) : 'Add Agreement'}</h1>
                                <p>MIS Report · Agreement</p>
                            </div>
                        </div>
                    </div>

                    {/* ---------- form card ---------- */}
                    {showLoader ? (
                        <AgreementFormSkeleton />
                    ) : (
                    <div className="aagr-card">
                        <div className="aagr-card-head">
                            <div className="aagr-badge">
                                <IconDoc />
                            </div>
                            <div>
                                <h2>Agreement Details</h2>
                                <p>
                                    Fields marked <span style={{ color: "var(--aagr-red)" }}>*</span> are required
                                </p>
                            </div>
                        </div>

                        <div className="aagr-fields">
                            {!id &&
                            <div className={"aagr-field" + (errors.client_id ? " is-invalid" : "")}>
                                <label className="aagr-lab">
                                    <IconUser /> Client <span className="aagr-req">*</span>
                                </label>
                                <Controller
                                    control={control}
                                    name="client_id"
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <CustomDropdown
                                            isDisable={id ? true : false}
                                            isSearchable={true}
                                            options={clientOption}
                                            selected={clientValue}
                                            onChange={(data: any) => {
                                                field.onChange(data.id)
                                                setClientValue(data.id);
                                            }}
                                        />
                                    )}
                                />
                                {errors.client_id && (
                                    <p className="aagr-err">
                                        <IconError /> Please Select Client.
                                    </p>
                                )}
                            </div>
                            }
                            <div className={"aagr-field" + (errors.agreement_type ? " is-invalid" : "")}>
                                <label className="aagr-lab">
                                    <IconType /> Agreement Type <span className="aagr-req">*</span>
                                </label>
                                <Controller
                                    control={control}
                                    name="agreement_type"
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <CustomDropdown
                                            isSearchable={true}
                                            options={agreementType}
                                            selected={agreementTypeSelected}
                                            onChange={(data: any) => {
                                                field.onChange(data.id)
                                                setAgreementTypeSelected(data.id);
                                            }}
                                        />
                                    )}
                                />
                                {errors.agreement_type && (
                                    <p className="aagr-err">
                                        <IconError /> Please Select Agreement Type.
                                    </p>
                                )}
                            </div>
                            <div className={"aagr-field" + (errors.duration_type ? " is-invalid" : "")}>
                                <label className="aagr-lab">
                                    <IconClock /> Duration Type <span className="aagr-req">*</span>
                                </label>
                                <Controller
                                    control={control}
                                    name="duration_type"
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <div className="sh-seg">
                                            <button type="button" className={"sh-seg-opt" + (field.value === 'Perpetual' ? " on" : "")} onClick={() => field.onChange('Perpetual')}>Perpetual</button>
                                            <button type="button" className={"sh-seg-opt" + (field.value === 'non_Perpetual' ? " on" : "")} onClick={() => field.onChange('non_Perpetual')}>Non Perpetual</button>
                                        </div>
                                    )}
                                />
                                {errors.duration_type && (
                                    <p className="aagr-err">
                                        <IconError /> Please Select Duration Type.
                                    </p>
                                )}
                            </div>

                            {(watchAllFields.duration_type == "Perpetual" || watchAllFields.duration_type == "non_Perpetual") &&
                            <div className={"aagr-field" + (errors.start_date ? " is-invalid" : "")}>
                                <label className="aagr-lab">
                                    <IconCalendar /> Start Date <span className="aagr-req">*</span>
                                </label>
                                <Controller
                                    control={control}
                                    name="start_date"
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <CustomDatePicker
                                            popperClassName="pav-datepicker-pop"
                                            popperPlacement="bottom-start"
                                            portalId="aagr-datepicker-portal"
                                            dropdownMode="scroll"
                                            scrollableYearDropdown={true}
                                            yearDropdownItemNumber={100}
                                            // minData={agreementTypeSelected == "AADHAR_E_SIGN" || agreementTypeSelected == "E_SIGN"? new Date() : undefined}
                                            // maxData={agreementTypeSelected == "SCANED_BY_BOTH" ? new Date() : undefined}
                                            selected={startDate}
                                            // isDisabled={isRenewAgreement ? true : false}
                                            onChange={(data: any) => {
                                                handleNewStartDate(data);
                                                field.onChange(data);
                                            }}
                                        />
                                    )}
                                />
                                {errors.start_date && (
                                    <p className="aagr-err">
                                        <IconError /> Please Select Start Date.
                                    </p>
                                )}
                            </div>
                            }
                              {watchAllFields.duration_type == "non_Perpetual" &&
                            <div className={"aagr-field" + (errors.end_date ? " is-invalid" : "")}>
                                <label className="aagr-lab">
                                    <IconCalendar /> End Date <span className="aagr-req">*</span>
                                </label>
                                <Controller
                                    control={control}
                                    name="end_date"
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <CustomDatePicker
                                            popperClassName="pav-datepicker-pop"
                                            popperPlacement="bottom-start"
                                            portalId="aagr-datepicker-portal"
                                            dropdownMode="scroll"
                                            scrollableYearDropdown={true}
                                            yearDropdownItemNumber={100}
                                            minData={agreementTypeSelected == "AADHAR_E_SIGN" || agreementTypeSelected == "E_SIGN" && newStartDate? new Date(newStartDate) : agreementTypeSelected == "SCANED_BY_BOTH"?new Date(newStartDate):''}
                                            // maxData={agreementTypeSelected == "SCANED_BY_BOTH" ? new Date() : undefined}
                                            selected={endDate}
                                            onChange={(data: any) => {
                                                field.onChange(data);
                                            }}
                                        />
                                    )}
                                />
                                {errors.end_date && (
                                    <p className="aagr-err">
                                        <IconError /> Please Select End Date.
                                    </p>
                                )}
                            </div>
}
                            <div className={"aagr-field aagr-field-wide" + ((!watchAllFields.document_name && errors.document_name) ? " is-invalid" : "")}>
                                <div className="display-none" >
                                    <label className="label">
                                        First Name<span className=" text-red-600">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="dummy_input"
                                        className="form-control"
                                        {...register("document_name", {
                                            required: true,
                                        })}
                                    />
                                </div>
                                <label className="aagr-lab">
                                    <IconUploadCloud /> Upload Document <span className="aagr-req">*</span>
                                </label>
                                <div className="aagr-upload">
                                    <label className="aagr-upload-btn">
                                        <FiUpload size={18} />
                                        <span>Upload Document</span>
                                        <input type="file" title=""
                                            onChange={(e: any) => {
                                                onLoadImage(e)
                                            }
                                            }
                                        />
                                    </label>
                                    {documentName && <span className="aagr-file-chip"><IconDoc /> {documentName}</span>}
                                    <BsInfoCircle className="aagr-upload-info" title="Valid file types are doc,docx,pdf,bmp,jpg,jpeg,gif,png,ppt,pptx,xls,xlsx,txt. Max size of each file is 15MB" />
                                </div>
                                {!watchAllFields.document_name && errors.document_name && (
                                    <p className="aagr-err">
                                        <IconError /> Please Upload Document
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                    )}

                    {/* bottom action bar — floats as a sticky card when the page scrolls */}
                    <div className={"aagr-actionbar" + (isActionsFloating ? " aagr-actionbar--float" : "")}>
                        <div className="aagr-actionbar-inner">
                            <button type="button" className="btn btn-white" onClick={goBack}>Cancel</button>
                            <button type="submit" className="btn btn-brand">
                                {isLoading && <img src={loader} className='spinner' alt="" />}{p_id ? "Save" : "Generate"}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    )
}
export default AddAgreement;
